var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "22px",
    viewBox: "0 0 32 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Communication&amp;Connectivity/Email/Unread/32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Express-Interest-flow-V2-Final-Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.-EI---Overview",
    transform: "translate(-1211.000000, -819.000000)",
    fill: "#00095B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(1132.000000, 814.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Communication&Connectivity/Email/Unread/32",
    transform: "translate(79.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,22 L32,22 L32,0 L0,0 L0,22 Z M28.4444444,1.80327869 L15.8222222,13.3442623 L3.37777778,1.80327869 L28.4444444,1.80327869 Z M14.5777778,14.6065574 C15.4666667,15.3278689 16.7111111,15.3278689 17.4222222,14.6065574 L19.9111111,12.2622951 L28.4444444,20.0163934 L3.37777778,20.0163934 L12.0888889,12.2622951 L14.5777778,14.6065574 Z M10.6666667,10.8196721 L2.13333333,18.7540984 L2.13333333,3.06557377 L10.6666667,10.8196721 Z M30.0444444,18.7540984 L21.5111111,10.8196721 L30.0444444,3.06557377 L30.0444444,18.7540984 Z",
    id: "EmailUnread"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.a14323c5b06c0ace1004b53b73112026.svg";
export { ForwardRef as ReactComponent };